export type Vec2 = { x: number, y: number };

export abstract class VectorMath {
  static add(a: Vec2, b: Vec2) {
    return {
      x: a.x + b.x,
      y: a.y + b.y
    };
  }

  static subtract(a: Vec2, b: Vec2) {
    return {
      x: a.x - b.x,
      y: a.y - b.y
    };
  }

  static multiply(v: Vec2, scalar: number) {
    return {
      x: v.x * scalar,
      y: v.y * scalar
    };
  }

  static invert(v: Vec2) {
    return VectorMath.multiply(v, -1);
  }

  static divide(v: Vec2, scalar: number) {
    return {
      x: v.x / scalar,
      y: v.y / scalar
    };
  }

  static magnitude(v: Vec2) {
    const x2 = Math.pow(v.x, 2);
    const y2 = Math.pow(v.y, 2);
    return Math.sqrt(x2 + y2);
  }

  static distanceBetween(a: Vec2, b: Vec2) {
    const diff = VectorMath.subtract(a, b);
    return VectorMath.magnitude(diff);
  }
}
